<template>
    <div v-show="visible">
        <el-dialog title="新增"  v-loading="loading" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="150px">
                    <el-form-item prop="name" label="策略名称">
                        <el-input v-model="form.name" maxlength="80" style="width:195px;"></el-input>
                    </el-form-item>
                    
                    <el-form-item prop="deviceNo" label="人脸设备编号">
                        <el-select v-model="form.deviceNo" clearable placeholder="请选择">
                            <el-option
                                v-for="item in devices"
                                :key="item.deviceNo"
                                :label="item.deviceNo"
                                :value="item.deviceNo">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="hkDeviceNo" label="录播设备编号">
                        <el-select v-model="form.hkDeviceNo" clearable placeholder="请选择">
                            <el-option
                                v-for="item in hkdevices"
                                :key="item.deviceNo"
                                :label="item.deviceNo"
                                :value="item.deviceNo">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="gateUser" label="科任老师">
                        <el-button @click="findUser()">{{form.userLabel}}</el-button>
                    </el-form-item>
                    
                    <el-form-item   prop="attendaceGroupId" label="绑定考勤组">
                        <el-select v-model="form.attendaceGroupId" clearable placeholder="请选择">
                            <el-option
                                v-for="item in attendaceGroups"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="classId" label="所属班级">
                        <el-cascader :show-all-levels="false"
                            :options="classes"
                            v-model="form.classId"
                            :props="props"
                            collapse-tags
                            clearable></el-cascader>
                    </el-form-item>

                    <el-form-item  prop="classHoursId" label="上课时间段">
                        <el-select v-model="form.classHoursId" clearable multiple collapse-tags placeholder="请选择">
                            <el-option
                            v-for="item in classHours"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="noticeClassTeacher" label="通知班主任(班级考勤)">
                          <el-checkbox v-model="form.noticeClassTeacher"></el-checkbox>
                    </el-form-item>

                    <el-form-item prop="hostelNoticeClassTeacher" label="通知班主任(宿舍考勤)">
                          <el-checkbox v-model="form.hostelNoticeClassTeacher"></el-checkbox>
                    </el-form-item>

                    <el-form-item prop="dpNoticeParent" label="通知家长(教职点评)">
                          <el-checkbox v-model="form.dpNoticeParent"></el-checkbox>
                    </el-form-item>

                    <el-form-item  prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="10" type="number"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                isAuto:false,
                transferVisible:false,
                props: { checkStrictly: true},
                form:{
                    id:"",
                    deptId:"",
                    classHoursId:"",
                    classId:"",
                    name:"",
                    deviceNo:"",
                    hkDeviceNo:"",
                    attendaceGroupId:"",
                    noticeClassTeacher:false,
                    hostelNoticeClassTeacher:false,
                    dpNoticeParent:false,
                    userId:[],
                    userLabel:"请选择",
                    orderNum:1
                },
                rules: {
                    name: [
                        { required: true, message: '请输入策略名称', trigger: 'blur' }
                    ],
                    attendaceGroupId: [
                        { required: true, message: '请选择绑定考勤组', trigger: 'blur' }
                    ],
                    classId: [
                        { required: true, message: '请选择所属班级', trigger: 'blur' }
                    ],
                    classHoursId: [
                        { required: true, message: '请选择上课时间', trigger: 'blur' }
                    ]
                },
                classes:[],
                devices:[],
                attendaceGroups:[],
                hkdevices:[],
                classHours:[]
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.userId=[];
                this.form.userLabel="请选择";
                this.form.deptId=deptId;
                this.form.noticeClassTeacher=false;
                this.form.hostelNoticeClassTeacher=false;
                this.form.dpNoticeParent=false,

                this.getClassHours();
                this.getDeptCascader();
                this.getDevices();
                this.getAttendaceGroup();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //获取班级
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.classes = res.data.selects; 
                      // console.log("班级列表:"+JSON.stringify(this.classes))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取设备
            getDevices(){
                // 获取考斯设备
                let url  = this.listDeviceSelectUrl;
                let data = {
                    deptId:this.form.deptId,
                    deviceTypeStr:'5',
                    commonSign:1
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.devices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });

                // 获取海康设备
                data = {
                    deptId:this.form.deptId,
                    deviceTypeStr:'8',
                    deptId:this.form.deptId,
                    commonSign:3
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.hkdevices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取上课时间
            getClassHours(){
                let url  = this.listClassHoursSelectUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("上课时间列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.classHours = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.userId)){
                        this.$refs['userTransfer'].init(2,this.form.userId,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.userId=keyArr;
                    this.form.userLabel="请选择";
                }else{
                    this.form.userId=keyArr;
                    this.form.userLabel=keyArr.length+"人";
                }
            },
            //获取考勤组
            getAttendaceGroup(){
                let url  = this.listAttendaceGroupDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("考勤组:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.attendaceGroups = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        this.loading=true;
                        let url = this.setClassroomTimeSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            classHoursId:this.form.classHoursId.join(","),
                            classId:this.form.classId[this.form.classId.length-1],
                            name:this.form.name,
                            ondutyTeacherId:this.form.userId.join(","),
                            deviceNo:this.form.deviceNo,
                            hkDeviceNo:this.form.hkDeviceNo,
                            attendaceGroupId:this.form.attendaceGroupId,
                            noticeClassTeacher:(this.form.noticeClassTeacher?1:2),
                            hostelNoticeClassTeacher:(this.form.hostelNoticeClassTeacher?1:2),
                            dpNoticeParent:(this.form.dpNoticeParent?1:2),
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.$commonFn.showTip(err,3);
                            this.loading=false;
                        });

                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/Add.vue